import { RouteEnum } from '@/layouts/routes/Route.model.ts';

export const SYSTEM_ROUTS = [
  '/logout',
  RouteEnum.LOGIN,
  RouteEnum.LOGIN_SUCCESSFUL,
  RouteEnum.MAINTENANCE,
  RouteEnum.NOT_AUTHORIZED,
  RouteEnum.NOT_FOUND,
];
